import React, { useState, useEffect } from 'react';

// "Remembering My Dog" — a separate, quiet memorial/aftercare experience.
// Deliberately NOT styled as a cheerful product carousel: no countdowns, no
// cross-selling, no urgency language. Shows only real, admin-added items.
const RememberingMyDog = () => {
  const [products, setProducts] = useState([]);
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/commerce/products?collection=memorial')
      .then(res => res.json())
      .then(data => {
        setProducts(data.products || []);
        setNote(data.note || '');
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="commerce-panel remembering-panel">
      <h2>Remembering My Dog</h2>
      <p className="commerce-subtitle">
        A quiet space for keepsakes, portraits and aftercare, whenever you need it.
        This section is kept separate from everyday shopping on purpose.
      </p>

      {loading && <p>Loading...</p>}

      {!loading && products.length === 0 && (
        <div className="commerce-empty">
          <p>{note}</p>
        </div>
      )}

      {!loading && products.length > 0 && (
        <div className="remembering-list">
          {products.map(p => (
            <div key={p.id} className="remembering-card">
              {p.image_url && <img src={p.image_url} alt={p.name} />}
              <h4>{p.name}</h4>
              {p.description && <p>{p.description}</p>}
              {p.price_gbp && <p className="commerce-price">£{Number(p.price_gbp).toFixed(2)}</p>}
              {p.product_url && <a href={p.product_url} target="_blank" rel="noopener noreferrer">View</a>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RememberingMyDog;
